export const BASE_URL = "https://devsusi.no/holidaze/wp-json/";
export const TOKEN_PATH = "jwt-auth/v1/token";
